package org.hs_soft.runmynesto.data.local_datasource.menu_data

import org.hs_soft.runmynesto.domain.model.menu.MenuFooterModel

import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

object MenuFooterData {
    val data = MenuFooterModel(
        id = "", //TODO(Must be fixed)
        settingIcon = Res.PathIcon.options,
        exitlloIcon = Res.PathIcon.exitApp,
        settingTitle = LanguageManager.getCurrentStrings().options,
        userName = LanguageManager.getCurrentStrings().USER_NAME,
        companyName = LanguageManager.getCurrentStrings().COMPANY_NAME,
    )
}